import { Currency } from '@mobi/utils/money'
import type { BetSlipItem } from '../types'

export const calculateTotalBonusesOnItems = (items: BetSlipItem[]) => {
  const bonusBetTotals = items.reduce(
    (total, { investment }) =>
      investment.win.isBonusBet || investment.place.isBonusBet
        ? total.add(investment.bonusBet?.value || 0)
        : total,
    new Currency(0)
  )

  const bonusCashTotals = items.reduce(
    (total, { investment }) =>
      investment.win.isBonusCash || investment.place.isBonusCash
        ? total.add(investment.bonusBet?.value || 0)
        : total,
    new Currency(0)
  )

  return {
    finalBonusBet: bonusBetTotals.value,
    finalBonusCash: bonusCashTotals.value,
  }
}
